module.exports = __webpack_public_path__ + "img/DSC01905 (1).52025621.jpg";